export default __webpack_public_path__ + "static/media/img1.4763acf0.png";